module.exports = __webpack_public_path__ + "dist/img/certificate.8e52236.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/certificate.jpg
// module id = lPKj
// module chunks = 1